import { CanActivateFn } from '@angular/router';
import { inject } from '@angular/core';
import { UserContextService } from '../services/user-context.service';
import { OAuthService } from 'angular-oauth2-oidc';

export const notConnectedGuard: CanActivateFn = async (route, state) => {
  const oauthService = inject(OAuthService);
  const userContext = inject(UserContextService);

  const token = oauthService.getAccessToken();

  if (token) {
    oauthService.logOut();
    userContext.clear();
  }

  return true;
};
